import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ScoreService {
    bankedScore$ = new BehaviorSubject<number>(0);

    bankScore(): void {
        // score accumulation implemented in EUP-99
    }

    fullReset(): void {
        this.bankedScore$.next(0);
    }
}
